valueOrArray